import { render, staticRenderFns } from "./wxwl-waixiao-gsj.vue?vue&type=template&id=50ce521c"
import script from "./wxwl-waixiao-gsj.vue?vue&type=script&lang=js"
export * from "./wxwl-waixiao-gsj.vue?vue&type=script&lang=js"
import style0 from "./wxwl-waixiao-gsj.vue?vue&type=style&index=0&id=50ce521c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports